import routes from './routes';
import { createRouter, createWebHistory } from 'vue-router';

// configure router
const router = createRouter({
    routes,
    linkExactActiveClass: 'active',
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
    history: createWebHistory(),
});

export default router;
